var forms = {"form":"_form_5e1f8_1","label":"_label_5e1f8_7","description":"_description_5e1f8_20","field":"_field_5e1f8_24","errors":"_errors_5e1f8_39","choices":"_choices_5e1f8_59","choice":"_choice_5e1f8_59"};

export { forms as default };
